import { Interpolation } from "@emotion/core";
import { grid } from "../../../../../design-tokens/grid";
import { DarkTheme } from "../../../../../design-tokens/media-queries";
import { Colors } from "../../../../../design-tokens/colors";
import { Border } from "../../../../../design-tokens/borders";
import { Fonts } from "../../../../../design-tokens/fonts";

const root: Interpolation = {
  marginBottom: grid(2),
};

const countryCard: Interpolation = {
  padding: `${grid(2)} ${grid(1)}`,
  backgroundColor: Colors.LightGrey,
  borderRadius: Border.Radius,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },
};

const content: Interpolation = {
  paddingLeft: grid(0.5),
  paddingRight: grid(0.5),
  marginTop: grid(0.5),
};

const countryLink: Interpolation = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: grid(5),
  fontSize: "18px",
  lineHeight: "22px",
  fontWeight: Fonts.Weight.Bold,
  textAlign: "center",

  ":hover": {
    textDecoration: "none",
  },
};

const detail: Interpolation = {
  display: "flex",
  justifyContent: "space-between",
  fontSize: "14px",
  lineHeight: grid(2),
  marginTop: grid(1),

  "> span": {
    fontWeight: Fonts.Weight.Bold,
  },
};

const styles = {
  root,
  countryCard,
  content,
  countryLink,
  detail,
};

export default styles;
